import React from 'react';
import DataComponent from './DataComponent';

function Home() {
  return (
    <div id="home-page">
      <DataComponent />
    </div>
  );
}

export default Home;
